import React, { useEffect, useState } from 'react'
import {
	string,
	shape,
	arrayOf,
	array,
	number,
	func,
	bool,
	object,
	oneOfType,
	node,
} from 'prop-types'
import { Table, Input, Button, Empty, Select } from 'antd'

const { Search } = Input

const DataTable = ({
	columns,
	dataSource,
	pages,
	onChangePageNumber,
	placeholderSearch,
	textButton,
	searchValue,
	filterValue,
	onSearch,
	filterOptions,
	onFilter,
	onClickButton,
	placeholderNoData,
	loading,
	buttons,
	rowSelection,
	onRow,
	extraComponent,
}) => {
	const [search, setSearch] = useState(searchValue || '')

	// Efeito para sincronizar o estado local se a prop mudar (ex: back/forward do navegador)
	useEffect(() => {
		setSearch(searchValue || '')
	}, [searchValue])

	return (
		<>
			<div
				className="toolbar-container"
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					width: '100%',
					margin: '24px 0',
					flexWrap: 'wrap',
					gap: '12px',
					position: 'relative',
					zIndex: 1,
				}}>
				<div
					className="toolbar-left"
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '8px',
						flex: '1 1 auto',
					}}>
					<Search
						placeholder={placeholderSearch}
						onSearch={(value) => onSearch({ search: value })}
						onChange={(e) => setSearch(e.target.value)}
						value={search}
						enterButton
						style={{
							maxWidth: '300px',
							width: '100%',
							position: 'relative',
							zIndex: 1,
						}}
					/>
					<Button onClick={onClickButton} type="primary">
						{textButton}
					</Button>
					{buttons.map((button, index) => (
						<Button type="primary" key={index} onClick={button.onClick}>
							{button.title}
						</Button>
					))}
				</div>

				<div
					className="toolbar-right"
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-end',
					}}>
					{extraComponent && (
						<div style={{ marginLeft: 'auto' }}>{extraComponent}</div>
					)}

					{!extraComponent && filterOptions && (
						<div style={{ minWidth: '200px' }}>
							<Select
								mode="multiple"
								allowClear
								style={{ width: '100%' }}
								placeholder="Filtros"
								value={filterValue}
								onChange={(selectedValues) => onFilter(selectedValues)}>
								{filterOptions.map((group) => (
									<Select.OptGroup key={group.label} label={group.label}>
										{group.options.map((item) => (
											<Select.Option
												key={item.value}
												value={item.value}
												{...item}>
												{item.label}
											</Select.Option>
										))}
									</Select.OptGroup>
								))}
							</Select>
						</div>
					)}
				</div>
			</div>
			<Table
				className="tabela-com-paginacao-centralizada"
				columns={columns}
				dataSource={dataSource}
				onRow={onRow}
				pagination={{
					showSizeChanger: true,
					pageSize: pages.per_page,
					position: ['bottomCenter'],
					total: pages.total,
					current: pages.page,
					onShowSizeChange: (page, perPage) =>
						onChangePageNumber({ page, perPage, search }),
					onChange: (page, perPage) =>
						onChangePageNumber({ page, perPage, search }),
					locale: { items_per_page: '' },
				}}
				locale={{
					emptyText: React.isValidElement(placeholderNoData) ? (
						placeholderNoData
					) : (
						<Empty description={placeholderNoData} />
					),
					triggerAsc: 'Clique para ordenar ascendente',
					triggerDesc: 'Clique para ordenar descendente',
					cancelSort: 'Clique para cancelar ordenação',
				}}
				loading={loading}
				rowSelection={rowSelection}
			/>
		</>
	)
}

DataTable.propTypes = {
	columns: arrayOf(
		shape({
			title: string,
			dataIndex: oneOfType([string, arrayOf(string)]),
		})
	).isRequired,
	dataSource: array.isRequired,
	pages: shape({
		per_page: number,
		page: number,
		total: number,
	}).isRequired,
	onChangePageNumber: func.isRequired,
	placeholderSearch: string,
	textButton: oneOfType([string, bool]),
	onSearch: func.isRequired,
	filterOptions: array,
	onFilter: func,
	onClickButton: func.isRequired,
	placeholderNoData: oneOfType([string, node]),
	loading: bool,
	buttons: array,
	rowSelection: object,
	onRow: func,
	searchValue: string,
	filterValue: array,
	extraComponent: node,
}

DataTable.defaultProps = {
	placeholderSearch: 'Search',
	placeholderNoData: 'Nenhum dado encontrado',
	filterOptions: null,
	onFilter: () => {},
	loading: false,
	buttons: [],
	onRow: () => ({}),
	searchValue: '',
	filterValue: [],
	extraComponent: null,
}

export default DataTable
